import script from "./BaseLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseLayout.vue?vue&type=script&setup=true&lang=ts"

import "./BaseLayout.vue?vue&type=style&index=0&id=ea04b83e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea04b83e"]])

export default __exports__